import { Injectable } from '@angular/core';
import { Http, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Headers, RequestOptions } from '@angular/http';
import { SessionService } from '../services/session.service';
import { BlockUIService } from './blockui.service';
import 'rxjs/add/operator/map';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Injectable()
export class HttpService {
    
    private pendingRequests = 0;
    
    constructor(private http: Http, private blockUIService: BlockUIService, private spinnerService: Ng4LoadingSpinnerService, 
        private sessionService: SessionService) {
    }

    public showSpinner(): void {
        this.pendingRequests++;
        if (this.pendingRequests === 1) {
        this.spinnerService.show();
        }
    }

    public hideSpinner(): void {
        this.pendingRequests = Math.max(0, this.pendingRequests - 1);
        if (this.pendingRequests === 0) {
        this.spinnerService.hide();
        }
    }

    public httpPost(object: any, url: string): Observable<any> {

        this.blockUIService.blockUIEvent.emit({
            value: true
        });

        let body = JSON.stringify(object);
        let headers = new Headers();
        headers.append('Content-Type', 'application/json; charset=utf-8');
        headers.append('Accept', 'q=0.8;application/json;q=0.9');
        headers.append('api-version', this.sessionService.version);
        headers.append('origen', 'Web');
        headers.append('origenAcceso', 'OBWEB');

        if (typeof (Storage) !== 'undefined') {

            let token = localStorage.getItem('Oficina.WebApi.Angular4.Token');
            headers.append('Authorization', token);
        }

        let options = new RequestOptions({ headers: headers });
        this.showSpinner();
        return this.http.post(url, body, options ).map((response) =>
        this.parseResponse(response, this.blockUIService, true)).catch((err) =>
        this.handleError(err, this.blockUIService, true));
    }

    public httpPostlectura(object: any, url: string): Observable<any> {

        this.blockUIService.blockUIEvent.emit({
            value: true
        });

        let headers = new Headers();
        headers.append('api-version', this.sessionService.version);
        headers.append('origen', 'Web');
        headers.append('origenAcceso', 'OBWEB');
        if (typeof (Storage) !== 'undefined') {

            let token = localStorage.getItem('Oficina.WebApi.Angular4.Token');
            headers.append('Authorization', token);
        }

        let options = new RequestOptions({ headers: headers });
        this.showSpinner();
        return this.http.post(url, object, options).map((response) => this.parseResponse(response, this.blockUIService, true))
            .catch((err) => this.handleError(err, this.blockUIService, true));
    }

    public httpPostWithNoBlock(object: any, url: string): Observable<any> {
        this.showSpinner();
        let body = JSON.stringify(object);
        let headers = new Headers();
        headers.append('Content-Type', 'application/json; charset=utf-8');
        headers.append('Accept', 'q=0.8;application/json;q=0.9');
        headers.append('api-version', this.sessionService.version);
        headers.append('origen', 'Web');
        headers.append('origenAcceso', 'OBWEB');

        if (typeof (Storage) !== 'undefined') {

            let token = localStorage.getItem('Oficina.WebApi.Angular4.Token');
            headers.append('Authorization', token);
        }

        let options = new RequestOptions({ headers: headers });
        
        return this.http.post(url, body, options).map((response) => this.parseResponse(response, this.blockUIService, false))
            .catch((err) => this.handleErrorresp(err, this.blockUIService, false));

    }


    private handleErrorresp(error: Response, blockUIService: BlockUIService, blocking: Boolean) {
        this.hideSpinner();
        let body = error.json();
        if (blocking) {
            blockUIService.blockUIEvent.emit({
                value: false
            });
        }

        return Observable.throw(body);

    }

    private handleError(error: any, blockUIService: BlockUIService, blocking: Boolean, loading: boolean = true) {
        if (loading) {
            this.hideSpinner();
        }
        let body = error.json();
        if (blocking) {
            blockUIService.blockUIEvent.emit({
                value: false
            });
        }

        return Observable.throw(body);

    }

    private parseResponse(response: any, blockUIService: BlockUIService, blocking: Boolean, loading: boolean = true) {
        let body = '';
        let authorizationToken = response.headers.get('Authorization');
        if (response._body !== '') {
            body = response.json();
            if (authorizationToken == null && body && body['Authorization']) {
                authorizationToken = body['Authorization'];
            }
        }
        if (authorizationToken != null) {
            if (typeof (Storage) !== 'undefined') {
                localStorage.setItem('Oficina.WebApi.Angular4.Token', authorizationToken);
            }
        }
        if (blocking) {
            blockUIService.blockUIEvent.emit({
                value: false
            });
        }
        if (loading) {
            this.hideSpinner();
        }
        return body;
    }

    public httpPut(object: any, url: string): Observable<any> {

                this.blockUIService.blockUIEvent.emit({
                    value: true
                });
                let body = JSON.stringify(object);

                let headers = new Headers();
                headers.append('Content-Type', 'application/json; charset=utf-8');
                headers.append('Accept', 'q=0.8;application/json;q=0.9');
                headers.append('api-version', this.sessionService.version);
                headers.append('origen', 'Web');
                headers.append('origenAcceso', 'OBWEB');

                if (typeof (Storage) !== 'undefined') {

                    let token = localStorage.getItem('Oficina.WebApi.Angular4.Token');
                    headers.append('Authorization', token);
                }

                let options = new RequestOptions({ headers: headers });
                this.showSpinner();
                return this.http.put(url, body, options).map((response) => this.parseResponse(response, this.blockUIService, true))
                    .catch((err) => this.handleError(err, this.blockUIService, true));
    }

    public putDownloadFile(object: any, url: string): Observable<any> {

        let body = JSON.stringify(object);

        let headers = new Headers();
        headers.append('Content-Type', 'application/json; charset=utf-8');
        headers.append('Accept', 'application/pdf');
        headers.append('api-version', this.sessionService.version);
        headers.append('origen', 'Web');
        headers.append('origenAcceso', 'OBWEB');

        if (typeof (Storage) !== 'undefined') {

            let token = localStorage.getItem('Oficina.WebApi.Angular4.Token');
            headers.append('Authorization', token);
        }

        let options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        this.showSpinner();
        return this.http.put(url, body, options)
                        .map(response =>  this.parseResponseDownloadPDF(response))
                        .catch((err) => this.handleError(err, this.blockUIService, true));
    }

    public parseResponseDownloadPDF(response: Response) {
        this.hideSpinner();
        return new Blob([response.blob()], {type: 'application/pdf'});
    }

    public httpGet(url: string): Observable<any> {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json; charset=utf-8');
        headers.append('Accept', 'q=0.8;application/json;q=0.9');
        headers.append('api-version', this.sessionService.version);
        headers.append('origen', 'Web');
        headers.append('origenAcceso', 'OBWEB');

        let options = new RequestOptions({ headers: headers });
        return this.http.get(url, options).map((response) => this.parseResponse(response, this.blockUIService, true, false))
        .catch((err) => this.handleError(err, this.blockUIService, true, false));
    }

    public httpGetAuthorizated(url: string, loading: boolean = false): Observable<any> {

        let headers = new Headers();
        headers.append('Content-Type', 'application/json; charset=utf-8');
        headers.append('Accept', 'q=0.8;application/json;q=0.9');
        headers.append('api-version', this.sessionService.version);
        headers.append('origen', 'Web');
        headers.append('origenAcceso', 'OBWEB');

        if (typeof (Storage) !== 'undefined') {

            let token = localStorage.getItem('Oficina.WebApi.Angular4.Token');
            headers.append('Authorization', token);
        }

        let options = new RequestOptions({ headers: headers });

        if (loading) {
            this.showSpinner();
        }
        return this.http.get(url, options).map((response) => this.parseResponse(response, this.blockUIService, true, loading))
        .catch((err) => this.handleError(err, this.blockUIService, true, loading));
    }
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/services/http.service.ts